import React from 'react';
import { Star } from 'lucide-react';

/**
 * Premium driver badge — shown beside a driver's name on jobs/offers.
 * Gold/amber styling so it stands out without screaming. Mobile-friendly.
 *
 *   <PremiumBadge />
 *   <PremiumBadge size="sm" />   // compact
 *   <PremiumBadge label="Premium" />
 */
export const PremiumBadge = ({ size = 'md', label = 'Premium Driver 🚚', dataTestId }) => {
  const sizes = {
    sm: { wrap: 'px-1.5 py-0.5 text-[10px] gap-0.5', icon: 'w-2.5 h-2.5' },
    md: { wrap: 'px-2 py-0.5 text-[11px] gap-1',     icon: 'w-3 h-3' },
    lg: { wrap: 'px-2.5 py-1 text-xs gap-1',          icon: 'w-3.5 h-3.5' },
  };
  const s = sizes[size] || sizes.md;
  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full bg-gradient-to-r from-amber-100 to-yellow-100 text-amber-800 border border-amber-300 shadow-sm whitespace-nowrap ${s.wrap}`}
      title="Premium driver — verified high performer"
      data-testid={dataTestId || 'premium-badge'}
    >
      <Star className={`${s.icon} fill-amber-500 text-amber-500`} strokeWidth={1.5} />
      {label}
    </span>
  );
};

export default PremiumBadge;
